var React = require('react');

function ProductHuntInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#D85637","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.71428 6H13.7143C16.0812 6 18 7.91878 18 10.2857C18 12.6526 16.0812 14.5714 13.7143 14.5714H10.2857V18H7.71428V6ZM10.2857 12V8.57143H13.7143C14.6611 8.57143 15.4286 9.33894 15.4286 10.2857C15.4286 11.2325 14.6611 12 13.7143 12H10.2857Z","fill":"white","key":1})]);
}

ProductHuntInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ProductHuntInline;

ProductHuntInline.default = ProductHuntInline;
